// utils/pricingCalculator.js
export const calculateRoomPrice = (rate, adultsCount, childrenCount, extraAdults = null) => {
  console.log('🧮 CALCULATE ROOM PRICE CALLED:', {
    rateName: rate.name,
    rateId: rate.id,
    adultsCount,
    childrenCount,
    extraAdults,
    adultPricing: rate.adult_pricing,
    extraBedPricing: rate.extra_bed_pricing
  });
  
  let totalPrice = 0;
  
  // If extraAdults is not provided, calculate it
  const baseAdults = Math.min(adultsCount, 3); // Assuming max base adults is 3
  const actualExtraAdults = extraAdults !== null ? extraAdults : Math.max(0, adultsCount - baseAdults);
  
  console.log('📊 BASE CALCULATION:', {
    baseAdults,
    actualExtraAdults,
    childrenCount
  });
  
  // Calculate BASE adult pricing (for up to 3 adults)
  if (rate.adult_pricing) {
    console.log('👨‍👩‍👧‍👦 SEARCHING ADULT PRICING FOR:', baseAdults);
    
    const adultPrice = rate.adult_pricing.find(ap => ap.adults_count === baseAdults);
    
    if (adultPrice) {
      totalPrice += adultPrice.price;
      console.log('✅ FOUND ADULT PRICE:', adultPrice.price);
    } else {
      // If no exact match, use the maximum available
      const maxAdultPrice = rate.adult_pricing.reduce((max, ap) => 
        ap.adults_count > max.adults_count ? ap : max
      );
      totalPrice += maxAdultPrice.price;
      console.log('⚠️ USING MAX ADULT PRICE:', maxAdultPrice.price);
    }
  } else {
    // Fallback if no adult_pricing structure
    totalPrice += rate.base_price || rate.originalPrice;
    console.log('🔄 USING BASE PRICE:', rate.base_price || rate.originalPrice);
  }
  
  // Calculate EXTRA adult pricing (beyond base adults)
  if (actualExtraAdults > 0 && rate.extra_bed_pricing) {
    const extraBedPrice = rate.extra_bed_pricing[0]?.adult_extra_bed_price || 0;
    totalPrice += (extraBedPrice * actualExtraAdults);
    console.log('🛏️ EXTRA BED CALCULATION:', {
      extraBedPrice,
      actualExtraAdults,
      totalExtra: extraBedPrice * actualExtraAdults
    });
  }
  
  // Calculate child pricing
  if (rate.child_pricing && childrenCount > 0) {
    console.log('👶 SEARCHING CHILD PRICING FOR:', childrenCount);
    
    const childPrice = rate.child_pricing.find(cp => cp.children_count === childrenCount);
    
    if (childPrice) {
      totalPrice += childPrice.price;
      console.log('✅ FOUND CHILD PRICE:', childPrice.price);
    } else {
      // Use the maximum children count pricing available
      const maxChildPrice = rate.child_pricing.reduce((max, cp) => 
        cp.children_count > max.children_count ? cp : max
      );
      totalPrice += maxChildPrice.price;
      console.log('⚠️ USING MAX CHILD PRICE:', maxChildPrice.price);
    }
  } else {
    console.log('➖ NO CHILD PRICING OR ZERO CHILDREN');
  }
  
  console.log('💰 FINAL TOTAL PRICE:', totalPrice);
  return totalPrice;
};